import { render } from "./oldPage.vue?vue&type=template&id=3cef0be2"
import script from "./oldPage.vue?vue&type=script&lang=js"
export * from "./oldPage.vue?vue&type=script&lang=js"
script.render = render

export default script